import { useMemo } from 'react';
import { grid_theme } from 'framework/Grid/hooks/constants';
import { useThemeContext } from 'framework/theme/context/ThemeContext';

import { GridTheme, GridThemePartial } from '../types';

export const useGridTheme = (theme: Partial<GridThemePartial> = grid_theme): GridTheme => {
  const {
    theme: {
      grid: { general, color, header, cell, summary, scrollbar },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      color: { ...color, ...theme.color },
      header: { ...header, ...theme.header },
      cell: { ...cell, ...theme.cell },
      summary: { ...summary, ...theme.summary },
      scrollbar: { ...scrollbar, ...theme.scrollbar },
    }),
    [theme, general, header, color, cell, summary, scrollbar]
  );
};
